import logger from 'utils/logger.util';

const L = logger('shallowCopyArray');

const shallowCopyArray = (array) => {
  if (Array.isArray(array)) {
    return [...array];
  }

  L.warn('()', 'Invalid array:', array);
  return [];
};

// noinspection JSUnusedGlobalSymbols
export default shallowCopyArray;
